import React, { useRef, useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import i18n from '../../i18n';
import HomeApi from '../../api/Home';
import HandleErrors from '../../utils/HandleErrors';
import Home from '../../models/Home';
import ImageApi from '../../api/Image';
import { fetchHomes } from '../../actions/homes';
import Loading from '../common/Loading';
import CollectionFunnelEvents from '../../utils/collectionFunnelEvents';
import { Icon } from '@homeexchange/design';

const UploadImages = (props) => {
    const [errorFile, setErrorFile] = useState('');
    const { handleSubmit } = useForm();
    const navigate = useNavigate();
    const fileInputRef = useRef();

    useEffect(() => {
        if (!props.home) {
            props.fetchHomes();
        }
    }, []);

    useEffect(() => {
        if (props.home) {
            props.hasError(!(props.home.get('images').length >= 5));
        }
    }, [props.home]);

    const onSubmit = () => {
        if (props.optional) {
            navigate(location.pathname.replace(/[^/]*$/, 'step6'));
        }
        if (props.home.get('images').length >= 5) {
            props.getSending(true);
            CollectionFunnelEvents.funnelProgress(5);
            setErrorFile('');
            HomeApi.pingCollectionHomeImages().then(() =>
                navigate(location.pathname.replace(/[^/]*$/, 'step6'))
            );
        } else {
            setErrorFile(i18n.t('collection:please_upload'));
        }
    };

    const uploadFiles = (files) => {
        const { home } = props;
        const update = [];
        // create promises list with each upload file requests
        for (let i = 0; i < files.length; i++) {
            update.push(ImageApi.post('home', home.id, files[i]));
        }
        return Promise.all(update).then(() => props.fetchHomes());
    };

    const handleUpload = (e) => {
        const { files } = e.target;
        uploadFiles(files);
        e.target.value = null;
    };

    const deleteImage = (id) => {
        ImageApi.delete(id).then(() => props.fetchHomes());
    };

    const renderImages = () =>
        props.home &&
        props.home.get('images').map((image) => (
            <div
                className="uploaded_images"
                key={image.id}
                style={{ backgroundImage: `url(${image.cdn_link})` }}
            >
                <Icon name="Cross" onClick={() => deleteImage(image.id)} />
            </div>
        ));

    const imgLenght = props.home && props.home.get('images').length > 0;

    return (
        <form id="form-step-5" onSubmit={handleSubmit(onSubmit)}>
            <h2 className="title-images">{i18n.t('collection:how_does_step_5')}</h2>
            <div className="container-form-group">
                <div className="text-home">
                    <p>{i18n.t('collection:add_at_least')}</p>
                </div>
                {!props.home ? (
                    <Loading />
                ) : (
                    <div
                        className={classNames('form-group', {
                            'form-group-upload': !imgLenght
                        })}
                    >
                        {imgLenght && (
                            <div className="form-label form-upload">
                                <label htmlFor="images">{i18n.t('collection:uploaded_photos')}</label>
                            </div>
                        )}
                        {errorFile && HandleErrors.renderErrors('files[]', errorFile)}
                        <input
                            ref={fileInputRef}
                            id="inputUploadFile"
                            type="file"
                            name="files[]"
                            multiple
                            accept="capture=camera, image/jpeg, image/png"
                            // eslint-disable-next-line react/jsx-no-bind
                            onChange={handleUpload}
                            hidden
                        />
                        <div
                            className={classNames('container-images', {
                                widthContainer: imgLenght
                            })}
                        >
                            <button
                                type="button"
                                className={imgLenght ? 'upload' : 'container-upload'}
                                // eslint-disable-next-line react/jsx-no-bind
                                onClick={() => fileInputRef.current.click()}
                            >
                                <div>
                                    <Icon name={imgLenght ? 'ArrowUpFromLine' : 'ArrowsOut'} />
                                    {imgLenght && (
                                        <div className="drag-and-drop">
                                            {i18n.t('collection:upload_more_photos')}
                                        </div>
                                    )}
                                </div>
                                {!imgLenght && (
                                    <div className="upload-from">{i18n.t('collection:upload_from')}</div>
                                )}
                            </button>
                            {renderImages()}
                        </div>
                    </div>
                )}
            </div>
        </form>
    );
};

UploadImages.propTypes = {
    home: PropTypes.instanceOf(Home),
    optional: PropTypes.bool,
    fetchHomes: PropTypes.func,
    getSending: PropTypes.func,
    hasError: PropTypes.func
};

const mapStateToProps = (state) => ({
    home: state.homes ? state.homes[0] : null
});

const mapDispatchToProps = (dispatch) => ({
    fetchHomes: bindActionCreators(fetchHomes, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(UploadImages);
